export default __webpack_public_path__ + "static/media/sim-torino.a31eb911.jpg";